import { render, staticRenderFns } from "./gongdan_zhuangtai.vue?vue&type=template&id=10760fdc&scoped=true&"
import script from "./gongdan_zhuangtai.vue?vue&type=script&lang=js&"
export * from "./gongdan_zhuangtai.vue?vue&type=script&lang=js&"
import style0 from "./gongdan_zhuangtai.vue?vue&type=style&index=0&id=10760fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10760fdc",
  null
  
)

export default component.exports